/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils, Contract, ContractFactory } from "ethers";
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        name: "ContractUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "chainId_",
                type: "uint16",
            },
        ],
        name: "bridgeContracts",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "completeTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenID",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "uri",
                        type: "string",
                    },
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "toChain",
                        type: "uint16",
                    },
                ],
                internalType: "struct NFTBridgeStructs.Transfer",
                name: "transfer",
                type: "tuple",
            },
        ],
        name: "encodeTransfer",
        outputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "isTransferCompleted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "isWrappedAsset",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseRegisterChain",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chainId",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainID",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                ],
                internalType: "struct NFTBridgeStructs.RegisterChain",
                name: "chain",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseTransfer",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "tokenID",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "uri",
                        type: "string",
                    },
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "toChain",
                        type: "uint16",
                    },
                ],
                internalType: "struct NFTBridgeStructs.Transfer",
                name: "transfer",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "newContract",
                        type: "bytes32",
                    },
                ],
                internalType: "struct NFTBridgeStructs.UpgradeContract",
                name: "chain",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "registerChain",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "splCache",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                ],
                internalType: "struct NFTBridgeStorage.SPLCache",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenID",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "recipientChain",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "recipient",
                type: "bytes32",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "transferNFT",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "wormhole",
        outputs: [
            {
                internalType: "contract IWormhole",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "tokenChainId",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "tokenAddress",
                type: "bytes32",
            },
        ],
        name: "wrappedAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
var NFTBridgeImplementation__factory = /** @class */ (function (_super) {
    __extends(NFTBridgeImplementation__factory, _super);
    function NFTBridgeImplementation__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    NFTBridgeImplementation__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    NFTBridgeImplementation__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    NFTBridgeImplementation__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    NFTBridgeImplementation__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    NFTBridgeImplementation__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    NFTBridgeImplementation__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    NFTBridgeImplementation__factory.bytecode = _bytecode;
    NFTBridgeImplementation__factory.abi = _abi;
    return NFTBridgeImplementation__factory;
}(ContractFactory));
export { NFTBridgeImplementation__factory };
